// Resource cards — a featured card carries a persistent .active class (same
// visual treatment as :hover, see _cards.scss). Hovering a sibling card should
// suppress that so only one card looks highlighted at a time; restore it on
// mouseleave.

document.querySelectorAll('.resource-cards-section .row').forEach(function (row) {
    var cards = row.querySelectorAll('.simple-display-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
        if (card.classList.contains('active')) {
            card.dataset.featured = 'true';
        }

        card.addEventListener('mouseenter', function () {
            cards.forEach(function (other) {
                if (other !== card) other.classList.remove('active');
            });
        });

        card.addEventListener('mouseleave', function () {
            cards.forEach(function (other) {
                if (other.dataset.featured === 'true') other.classList.add('active');
            });
        });
    });
});
